import { Typography } from '@mui/material';
import { InvoiceItem } from 'types/graphql';

import { Card, LineItemTable } from 'src/components';

interface InvoiceItemsProps {
    lineItems: InvoiceItem[];
    usersCurrency: string;
}

const InvoiceItems = ({ lineItems, usersCurrency }: InvoiceItemsProps) => {
    return (
        <Card gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Invoice Items
            </Typography>
            <LineItemTable
                columnHeaders={[
                    'Ledger Account',
                    'Description',
                    'Quantity',
                    'Net Amount',
                    'Total Line Vat',
                    'Line Total',
                ]}
                data={lineItems?.map(
                    ({ description, ledgerAccount, lineTotal, netAmount, totalVat, quantity }) => {
                        return {
                            quantity,
                            description,
                            ledgerAccount,
                            lineTotal,
                            netAmount,
                            totalLineVat: totalVat,
                        };
                    }
                )}
                showLedgerAccount
                usersCurrency={usersCurrency}
            />
        </Card>
    );
};
export default InvoiceItems;
